import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'downChevron',
    'upChevron',
    'clickToClose',
    'menu'
  ]

  connect() {
  }

  toggle() {
    this.menuTarget.classList.toggle('hidden');
    this.menuTarget.classList.toggle('block');

    this.clickToCloseTarget.classList.toggle('hidden');
    this.clickToCloseTarget.classList.toggle('block');

    this.downChevronTarget.classList.toggle('hidden');
    this.upChevronTarget.classList.toggle('hidden');
  }
}
